import type { AuthGateState } from '../auth/auth-navigation';

const PRODUCT_TITLE = 'Tidal Inventory';

export function formatPageTitle(page: string): string {
  return `${PRODUCT_TITLE} - ${page}`;
}

export function pageTitle(pathname: string, search: string): string {
  if (new URLSearchParams(search).has('authError')) return formatPageTitle('Sign-in issue');
  if (pathname === '/') return formatPageTitle('Dashboard');
  if (pathname === '/inventory') {
    return formatPageTitle(
      new URLSearchParams(search).has('attention') ? 'Exceptions' : 'Inventory',
    );
  }
  if (pathname.startsWith('/inventory/')) {
    const itemId = pathname.slice('/inventory/'.length);
    try {
      return formatPageTitle(decodeURIComponent(itemId));
    } catch {
      return formatPageTitle(itemId);
    }
  }
  if (pathname === '/parts') return formatPageTitle('Parts');
  if (pathname === '/sites') return formatPageTitle('Customers and sites');
  if (pathname === '/customers') return formatPageTitle('Customers');
  if (/^\/customers\/[^/]+\/sites\/[^/]+$/.test(pathname)) return formatPageTitle('Site');
  if (pathname.startsWith('/customers/')) {
    const customerId = pathname.slice('/customers/'.length);
    try {
      return formatPageTitle(decodeURIComponent(customerId));
    } catch {
      return formatPageTitle(customerId);
    }
  }
  if (pathname === '/shipments') return formatPageTitle('Shipments');
  if (pathname === '/shipments/shipped-items') return formatPageTitle('Shipped items');
  if (pathname.startsWith('/shipments/')) return formatPageTitle('Shipment');
  if (pathname === '/goods-intake') return formatPageTitle('Goods intake');
  if (pathname.startsWith('/goods-intake/')) return formatPageTitle('Goods receipt');
  if (pathname === '/stock') return formatPageTitle('Stock');
  if (pathname.startsWith('/stock/items/')) return formatPageTitle('Stock item');
  if (pathname === '/fulfillment') return formatPageTitle('Pick & pack');
  if (pathname === '/fulfillment/templates') return formatPageTitle('Order templates');
  if (/^\/fulfillment\/[^/]+\/packing-list$/.test(pathname)) {
    return formatPageTitle('Packing list');
  }
  if (pathname.startsWith('/fulfillment/')) return formatPageTitle('Fulfillment order');
  if (pathname === '/field-work') return formatPageTitle('Field work');
  if (pathname === '/field-work/board') return formatPageTitle('Field work board');
  if (pathname === '/field-work/reports') return formatPageTitle('Field work reports');
  if (pathname === '/field-work/settings') return formatPageTitle('Queue owners');
  if (pathname.startsWith('/field-work/')) {
    const requestId = pathname.slice('/field-work/'.length);
    try {
      return formatPageTitle(`Field work ${decodeURIComponent(requestId)}`);
    } catch {
      return formatPageTitle(`Field work ${requestId}`);
    }
  }
  if (pathname === '/audit') return formatPageTitle('Audit');
  if (pathname === '/help/developer') return formatPageTitle('Developer guide');
  if (pathname === '/help') return formatPageTitle('Help & guides');
  return formatPageTitle('Page unavailable');
}

export function resolveDocumentTitle({
  pathname,
  search,
  authGate,
  sessionUnavailable,
}: {
  pathname: string;
  search: string;
  authGate: AuthGateState;
  sessionUnavailable: boolean;
}): string {
  if (authGate === 'pending' || authGate === 'redirect') {
    return formatPageTitle('Signing in');
  }
  if (authGate === 'recovery') {
    return formatPageTitle(sessionUnavailable ? 'Session unavailable' : 'Sign-in issue');
  }
  return pageTitle(pathname, search);
}
